<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>区域管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input class="handle-input mr10"
					placeholder="输入关键字进行过滤"
					v-model="filterText" style="float:left">
				</el-input>&nbsp;&nbsp;
				<el-upload
					style="float:left;"
					class="upload-demo mr10"
					accept=".xls,.xlsx"
					action= "/blob/area/import-excel"
					:on-success="uploadSuccess"
					:file-list="fileList"
					:show-file-list = "false"
					list-type="picture">
					<el-button size="small" type="primary" icon="el-icon-folder-add">导入区域信息</el-button>
				</el-upload>
				<el-button type="primary" icon="el-icon-lx-add" class="handle-del mr10" @click="handleAdd">添加记录</el-button>
            </div>
            <el-tree
			  :data="dataSource"
			  show-checkbox
			  node-key="id"
			  :expand-on-click-node="false"
			  :show-checkbox="false"
			  :filter-node-method="filterNode"
			  style="border:1px solid #eee; margin-top:20px;width:100%;"
			  ref = "tree"
			>
			<template #default="{ node, data }">
				<span class="custom-tree-node">
					<span>{{ node.label }}</span>
					<span>
						<el-button
                            type="text"
                            icon="el-icon-lx-add"
                            @click="append(node, data)"
							v-if="node.level < 3"
                        >新增</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="remove(node, data)"
                        >删除</el-button>
					</span>
				</span>
			</template>
			</el-tree>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
                <el-form-item label="编码" prop="code">
                    <el-input v-model="form.code"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="预览" :visible.sync="previewVisible" width="60%">
            <el-table
                :data="previewData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				height="500px"
				stripe
            >
                <el-table-column prop="code" label="编码"></el-table-column>
				<el-table-column prop="province" label="省"></el-table-column>
				<el-table-column prop="city" label="市"></el-table-column>
				<el-table-column prop="area" label="区"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="previewVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getAreaTreeData, saveArea, deleteArea, getArea, saveAreaBatch} from '../../../api/index';
export default {
    name: 'area_manage',
    data() {
        return {
            dataSource: [],
            editVisible: false,
            form: {},
			title:"",
			rules: {
                code: [{ required: true, message:'请输入编码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
            },
			previewData:{},
			uuid:"",
			previewVisible:false,
			fileList:[],
			filterText:""
        };
    },
    created() {
        this.getData();
    },
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		}
    },
    methods: {
		//节点过滤
		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
        // 获取树形结构数据
        getData() {
            getAreaTreeData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.dataSource = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 删除操作
        remove(node, data) {
            // 二次确认删除
            this.$confirm('确定要删除 ' + node.label + ' 吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteArea([data.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							const parent = node.parent;
							const children = parent.data.children || parent.data;
							const index = children.findIndex((d) => d.id === data.id);
							children.splice(index, 1);
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加省";
			this.editVisible = true;
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveArea(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		// 保存
        save() {
			saveAreaBatch(this.uuid).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.previewVisible = false;
					this.getData();
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			});
        },
		append(node, data) {
			this.form = {};
			this.form["parentId"] = data.id;
			this.title = "添加" + (node.level==1?"城市":"区县");
			this.editVisible = true;
		},
		uploadSuccess(response, file, fileList) {
			if (response.code == 0 ) {
				this.previewData = response.data.obj;
				this.uuid = response.data.uuid;
				this.previewVisible = true;
			} else {
				this.$message.error(response.message);
			}
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>

